<!--  -->
<template>
  <div class="card">
    <div style="">
      <h1 style="font-size: 20px">约仓管理</h1>
      <el-button
        type="primary"
        style="margin-top: 20px"
        @click="excelVisible = true"
      >
        导入约仓文件</el-button
      >
      <!-- <el-button type="primary" style="margin-top:20px" @click="donwLoadTemplate">
        下载模板</el-button
      > -->
      <div style="margin: 20px 0">
        <el-table :data="pageList" border>
          <el-table-column prop="boxNos" align="center" label="箱号">
          </el-table-column>
          <el-table-column prop="conWareNos" align="center" label="预约送仓号">
          </el-table-column>
          <el-table-column
            prop="conWareCode"
            align="center"
            label="预约送仓仓库"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="beginTime"
            align="center"
            label="预约送仓开始时间"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="endTime"
            align="center"
            label="预约送仓结束时间"
            width="180"
          >
          </el-table-column>
          <el-table-column prop="remark" align="center" label="描述">
          </el-table-column>
        </el-table>
      </div>

      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20,30,40, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalPage"
        >
        </el-pagination>
      </div>

      <!-- Excel上传 -->
      <el-dialog
        title="文件上传"
        :visible.sync="excelVisible"
        width="40%"
        center
      >
        <!--  :show-file-list="false" 是否显示上传文件的list -->
        <!-- drag  是否可拖拽 -->
        <!--  multiple 是否上传多文件 -->
        <!--   :action="upUrl" 上传地址 -->
        <el-upload
          style="text-align: center"
          :show-file-list="false"
          :on-error="handleError"
          :on-success="handleSuccess"
          :before-upload="handleBeforeUpload"
          class="upload-demo"
          drag
          :http-request="uploadSectionFile"
          action=""
          multiple
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">仅限xls和xlsx文件</div>
        </el-upload>
        <span slot="footer" class="dialog-footer">
          <el-button
            style="margin-right: 20px"
            size="mini"
            @click="excelVisible = false"
            >取 消</el-button
          >

          <el-button size="mini" @click="donwLoadTemplate" type="success"
            >下载模板</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      // 源数据列表的length
      totalPage:0,
      currentPage: 0,
      pageSize: 10,
      // 处理后的列表
      pageList: [],
      // 源数据列表
      list: [],

      
      //注意这里是和全路径，和全局axios没关系
      upUrl: "http://xxxx.cn:8060/erp/xxxxx",
      //   模板下载
      downUrl: "http://xxxx.cn:8060/erp/xxxxx",
      excelVisible: false,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    handleSizeChange(val) {
      // 只要换页数就直接返回1页
      this.pageSize = val;
      this.currentPage = 1;
      this.pageList = this.list.slice(0, this.pageSize);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      if (val == 1) {
        this.pageList = this.list.slice(0, this.pageSize);
        return;
      }
      // 当前页 - 1 * 页数 = 分割开始数 比如二页 - 1  = 1*page
      val = (val - 1) * this.pageSize;
      // 分割结束数 = 分割开始数 + this.pageSize
      this.pageList = this.list.slice(val, val + this.pageSize);
    },

    // 自定义上传
    uploadSectionFile(params) {
      // console.log(params);
      let form = new FormData();
      form.append("file", params.file);
      this.axios
        .post(`/busFbx/uploadFBNConWareInfo`, form)
        .then((res) => {
          if (res.data.code == 200) {
            console.log(res.data.datas);
            this.list = [...this.list, ...res.data.datas];
            // 总数据就是总页数
            this.totalPage = this.list.length
            // 给加分页列表初始化
            let temp = JSON.parse(JSON.stringify(this.list))
            // 因为splice不是纯函数会改变源数据结果这里temp一下，记得Stringify不然也会改变源数据
            this.pageList =  temp.splice(0,this.pageSize)
            this.excelVisible = false
          } else {
            this.$message(res.data.message || "模板有误或模板内容为空");
             this.excelVisible = false
          }
        })
        .catch((res) => {
          console.log(res);
           this.excelVisible = false
        });
    },
    donwLoadTemplate() {
      this.axios
        .get(`/busFbx/getFBNConWareTemplate`, {
          responseType: "arraybuffer" /* 一定要加这个 不然文件内容显示不了 */,
        })
        .then((res) => {
          let a = document.createElement("a");
          let blob = new Blob([res.data]);
          let objectUrl = URL.createObjectURL(blob);
          a.setAttribute("href", objectUrl);
          a.setAttribute("download", "约仓模板.xls");
          a.click();
          // console.log(objectUrl);
          URL.revokeObjectURL(objectUrl); // 释放内存
        })
        .catch((res) => {
          console.log(res);
        });
    },
    //失败时的方法
    handleError(err) {
      this.$message.info(err.data);
    },
    //成功时的方法
    handleSuccess(response) {
      //  console.log(response);
      if (response.isSuccess) {
        this.$message.success(response.error);
        this.getListByParam();
        return;
      }
      this.$message.info(response.error);
    },
    //上传之前校验的方法
    handleBeforeUpload(file) {
      // 校验
      let legalName = ["xlsx", "xls"];
      // 拿到后缀名
      let name = file.name.substring(
        file.name.lastIndexOf(".") + 1,
        file.name.length
      );
      if (legalName.includes(name)) {
        console.log(legalName.includes(name));
      } else {
        this.$message.info("文件格式不对，仅限xls和xlsx");
        return false;
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style  scoped>
.card {
  padding: 30px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/PersonalCenter/FBAheader/FbnAppointment.vue